export default {
  "card.cardHolder.notValid": `Veuillez vérifier le nom du propriétaire de la carte`,
  "card.cardNumber.notValid": `Veuillez vérifier le numéros de la carte`,
  "card.month.notValid": `Veuillez vérifier le mois d'expiration`,
  "card.year.notValid": `Veuillez vérifier l'année d'expiration`,
  "card.cvc.notValid": `Veuillez vérifier le CVC`,
  "order.card.success": "Paiement effectué avec succès ",
  "order.card.error": "Echecs du paiement"
};
